import { render, staticRenderFns } from "./ModalPengajuanPembatalanSertifikasi.vue?vue&type=template&id=5355f01f&"
import script from "./ModalPengajuanPembatalanSertifikasi.vue?vue&type=script&lang=js&"
export * from "./ModalPengajuanPembatalanSertifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports